import React, { useState } from 'react'
import { BsUpload } from 'react-icons/bs'
import {AiOutlineCloseCircle} from 'react-icons/ai'

export default function AVCImageSelection({displayImageOther,imgurl,removeImage,setSelectedImageIndex,selectedImageIndex}) {

    const [iserror, setIsError] = useState(false);
    // const [isLoaded, setIsLoaded] = React.useState(false);

    const onErrorHandle = (e) => {
    e.target.onerror = null
    e.target.src = '/imgesML/default-placeholder.png';
    setIsError(true);
    }


    const handleImageSelectionFun = (e) => {
        handleImageSelection(e);
        let firstIndex = +e.target.dataset.index;
        let secondIndex = firstIndex;
        if(imgurl.length === 1){
            setSelectedImageIndex([0,1])
        }else{
            if(firstIndex < imgurl.length-1){
                ++secondIndex;
                setSelectedImageIndex([firstIndex,secondIndex])
            }else{
                --secondIndex;
                setSelectedImageIndex([secondIndex,firstIndex])
            }
        }
    }

    const removeImgByIndex = (index) => {
        removeImage(index);
        setTimeout(()=>{
        if(imgurl.length-1===index){
            document.getElementById("preview-image"+(index-1)).click();
        }else if(selectedImageIndex[0]===index){
            document.getElementById("preview-image"+index).click();
        }
    },0)
    }
    
    const handleImageSelection = (e) => {
        let pics = document.getElementsByClassName("multiple-avc-images");
        for(let pic of pics)
            pic.style.background = "none";
  
        let img_serial = e.target.dataset.index;
        let ele_id = e.target.parentElement.id;
        let img_for_preview = document.getElementById(ele_id);
        let img_for_preview_adj;
        let ele_id2;
        
        if(imgurl.length===1){
            img_for_preview.style.background = "#FFECD3";
            document.getElementById("front").setAttribute("src",img_for_preview.dataset.sequence);
        }else{
            if(img_serial < imgurl.length-1){
                ele_id2 = "preview_image_container" + (++img_serial);
                img_for_preview_adj = document.getElementById(ele_id2);
                img_for_preview.style.background = "#FFECD3";
                img_for_preview_adj.style.background = "#FFECD3";
                document.getElementById("front").setAttribute("src",img_for_preview.dataset.sequence);
                document.getElementById("back").setAttribute("src",img_for_preview_adj.dataset.sequence);
            }else{
                if(imgurl.length > 1){
                ele_id2 = "preview_image_container" + (--img_serial);
                img_for_preview_adj = document.getElementById(ele_id2);
                img_for_preview.style.background = "#FFECD3";
                img_for_preview_adj.style.background = "#FFECD3";
                document.getElementById("front").setAttribute("src",img_for_preview_adj.dataset.sequence);
                document.getElementById("back").setAttribute("src",img_for_preview.dataset.sequence);
                }
            }
        }
        
    }

  return (
    <div className="multiple-upload-container">
        <label htmlFor="ml-upload-image" className='upload-button'>
            <div className='avc-images-input-container'>
                <BsUpload />
                <div>UPLOAD OTHER IMAGES</div>    
            </div>
        </label>
        <input type="file" accept=".jpg, .jpeg, .png" id="ml-upload-image" multiple onChange={displayImageOther} style={{ display: 'none' }} />
        {
            imgurl.map((avc_img_src, index) => {
                return <div id={"preview_image_container" + index} data-sequence={avc_img_src} className='multiple-avc-images'>
                    <img id={"preview-image"+index} src={avc_img_src} onError={onErrorHandle} alt={avc_img_src} data-index={index} width={52} height={54} onClick={handleImageSelectionFun} />
                    {index> 1 && <AiOutlineCloseCircle onClick={()=>removeImgByIndex(index)}/>}
                    {selectedImageIndex.includes(index) && <div className='preview-bar'></div>}
                </div>
            })
        }
    </div>
                                
  )
}
